<app-industry-report-suggestion></app-industry-report-suggestion>
